import React from "react";

import colors from "../theme/colors";

export default function FastTrackBadge() {
  return (
    <div
      style={{
        display: "inline-block",
        borderRadius: "2px",
        backgroundColor: colors.green,
        color: colors.white,
        padding: "5px 10px",
        whiteSpace: "nowrap",

        fontFamily: "Avenir",
        fontSize: "12px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "0.4px",
        textTransform: "uppercase"
      }}
    >
      Fast Track Verification
    </div>
  );
}
